module.exports = __webpack_public_path__ + "static/media/FENGYUN 2G.6ed7268c.czml";